import {
  CTA_BUTTON_COPY,
  CTA_BUTTON_COPY_2,
  CTA_BUTTON_COPY_8,
  CTA_BUTTON_COPY_9,
  CTA_LINK_2,
  CTA_LINK_3,
  FORM_IDS,
} from "components/data/landing-page-data";
import HeroVersionG from "components/landing-pages/experiments/HeroVersionG";
import AllInOneF from "components/landing-pages/surveillance/version-f/AllInOneF";
import CaseStudiesF from "components/landing-pages/surveillance/version-f/CaseStudiesF";
import FormSectionF from "components/landing-pages/surveillance/version-f/FormSectionF";
import HighlightsF from "components/landing-pages/surveillance/version-f/HighlightsF";
import PlatformF from "components/landing-pages/surveillance/version-f/PlatformF";

import GlobalLayout from "components/page/GlobalLayout";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";

export default function SurveillanceG() {
  const imageData = useStaticQuery(graphql`
    query {
      hero: file(
        relativePath: {
          eq: "components/landing-pages/experiments/assets/alert-hero-min.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      logo1: file(
        relativePath: { eq: "components/common/logos/goodwill-2-min.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 29, width: 170)
        }
      }
      logo2: file(
        relativePath: {
          eq: "components/landing-pages/experiments/assets/logos/ymca-logo.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 50, width: 79)
        }
      }
      logo3: file(
        relativePath: {
          eq: "components/landing-pages/experiments/assets/logos/amazon-logo.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 36, width: 117)
        }
      }
      logo4: file(relativePath: { eq: "components/common/logos/hurley.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 37, width: 135)
        }
      }
      logo5: file(
        relativePath: {
          eq: "components/landing-pages/experiments/assets/logos/aramark-logo.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 42, width: 148)
        }
      }
      logo6: file(
        relativePath: {
          eq: "components/landing-pages/experiments/assets/logos/clark-logo.png"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, height: 41, width: 136)
        }
      }
    }
  `);

  return (
    <GlobalLayout
      color="var(--gradient-light)"
      landingPage
      buttonText={CTA_BUTTON_COPY}
      includeButton
      useFullWidthLogo
      useExperimentalFooter
    >
      <Helmet>
        <title>Security + Surveillance Unified | Rhombus™</title>
        <meta
          name="description"
          content="Stay in the know from anywhere at anytime. Automated alerts and surveillance monitoring ensures your spaces, assets, and people are protected at all times."
        />
      </Helmet>
      <HeroVersionG
        imageEnd={false}
        imageData={imageData.hero}
        title={"Surveillance Optimized for Your Security Needs"}
        blurb={
          "The all-in-one cloud surveillance and security platform trusted by Leaders and IT Teams. Save countless hours in video surveillance operations with best-in-class features like AI video search, facial recognition, license plate recognition, and real-time alerts."
        }
        logos={[
          imageData.logo1,
          imageData.logo2,
          imageData.logo3,
          imageData.logo4,
          imageData.logo5,
          imageData.logo6,
        ]}
      />
      <HighlightsF />
      <PlatformF />
      <AllInOneF
        showCTA
        ctaData={{ title: CTA_BUTTON_COPY_9, link: CTA_LINK_2 }}
      />
      <CaseStudiesF />
      <FormSectionF
        formTitle={CTA_BUTTON_COPY_2}
        formSubmitText={CTA_BUTTON_COPY_8}
        formId={FORM_IDS.GET_QUOTE_ADS}
      />
    </GlobalLayout>
  );
}
